export const vitalsOptions = [
    { value: "blood_pressure", label: "Blood Pressure" },
    { value: "heart_rate", label: "Heart Rate" },
    { value: "temperature", label: "Temperature" },
    { value: "o2_saturation", label: "O2 Saturation" },
    { value: "respiration_rate", label: "Respiration Rate" },
    { value: "head_circumference", label: "Head Circumference" },
    { value: "height", label: "Height" },
    { value: "weight", label: "Weight" },
  ];
